var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHowPerson = function SvgHowPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 84"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Person wearing hard hat")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33B9EF",
    stroke: "#000",
    strokeWidth: 2,
    d: "M13.126 64.316v15.74a1.315 1.315 0 0 0 1.31 1.32h55.128zm0 0a17.055 17.055 0 0 1 17.065-17.065l23.618-.005m-40.683 17.07 40.683-17.07m0 0c2.241-.001 4.461.44 6.532 1.296m-6.532-1.296 6.532 1.296m9.237 9.237a17.1 17.1 0 0 1 1.296 6.532zm0 0a17.1 17.1 0 0 0-3.7-5.538m3.7 5.538-3.7-5.538m0 0a17.1 17.1 0 0 0-5.537-3.699m5.538 3.7-5.538-3.7M14.126 64.316A16.056 16.056 0 0 1 30.19 48.25h.001l23.618-.005A16.054 16.054 0 0 1 69.875 64.31v15.75a.32.32 0 0 1-.091.223l.71.704-.71-.704a.31.31 0 0 1-.221.093H14.438a.314.314 0 0 1-.312-.316V64.316Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD5A6",
    stroke: "#000",
    strokeWidth: 2,
    d: "M69.874 80.056v.007a.314.314 0 0 1-.314.313H14.44a.32.32 0 0 1-.314-.32v-5.558h55.748z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCE97",
    stroke: "#000",
    strokeWidth: 2,
    d: "M35.229 48.79h-.002v-.001l-.004-.004-.006-.006a.3.3 0 0 1-.087-.213v-8.198h13.74v8.206c.001.08-.03.159-.084.218l-.015.014-.083.077c-.077.07-.195.174-.353.301-.316.255-.786.6-1.387.945-1.207.693-2.907 1.37-4.94 1.37-2.039 0-3.74-.677-4.944-1.37-.6-.345-1.07-.69-1.385-.944a8 8 0 0 1-.434-.378l-.016-.016Zm22.834-18.623v.02c0 2.999-2.15 5.026-4.564 5.47v-8.102a3.2 3.2 0 0 1 1.263-.329q.48-.02.946.102l.011.003a3.1 3.1 0 0 1 2.344 2.835zm-28.82-2.94h.001c.434.019.86.13 1.252.322v8.108c-2.41-.444-4.558-2.467-4.558-5.47v-.02a3.1 3.1 0 0 1 2.343-2.836l.013-.003c.31-.082.63-.116.949-.102Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FDD5A6",
    stroke: "#000",
    strokeWidth: 2,
    d: "M34.434 40.291A10.8 10.8 0 0 1 31.19 32.8v-6.862h21.618V32.8a10.812 10.812 0 0 1-18.375 7.491Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBC42",
    stroke: "#000",
    strokeWidth: 2,
    d: "M32.502 10.184a13.436 13.436 0 0 1 22.899 8.5H28.604a13.44 13.44 0 0 1 3.898-8.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8AB3C",
    stroke: "#000",
    strokeWidth: 2,
    d: "m38.514 4.49.009-.008a3.13 3.13 0 0 1 2.158-.858l2.624.005h.006a3.18 3.18 0 0 1 2.186.857l.008.008a2.35 2.35 0 0 1 .731 2.148l-.001.01-1.305 7.828v.006a.315.315 0 0 1-.307.264h-5.248a.315.315 0 0 1-.309-.264l-.001-.006-1.308-7.854a2.43 2.43 0 0 1 .757-2.136Zm-9.643 20.752a2.95 2.95 0 0 1-2.933-2.934 2.95 2.95 0 0 1 2.934-2.933h26.257a2.953 2.953 0 0 1 2.934 2.933 2.953 2.953 0 0 1-2.934 2.934z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5575",
    stroke: "#000",
    strokeWidth: 2,
    d: "M27.252 60.687V48.532c.957-.18 1.936-.281 2.934-.281h1.63v12.436zm29.5 0H52.19V48.25h1.618c.989.002 1.974.096 2.945.28z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED5575",
    stroke: "#000",
    strokeWidth: 2,
    d: "M23.313 68.281c0-.056.016-.112.045-.16l3.974-6.587.005-.01a.31.31 0 0 1 .263-.152h28.806q.082 0 .154.042l.496-.867-.496.867a.3.3 0 0 1 .114.112l.004.006 3.963 6.588.005.008a.3.3 0 0 1 .046.157v12.09H23.313z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M31.841 72.53a3.26 3.26 0 0 1 2.29-.951h.002l15.736-.005a3.264 3.264 0 0 1 3.245 3.237v5.865H30.881v-5.86c.007-.859.352-1.68.96-2.285Z"
  })));
};
export default SvgHowPerson;